function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#85D0CC",
  d: "M17 21H7C6.47 21 5.96 20.79 5.59 20.41C5.22 20.03 5 19.53 5 19V5C5 4.47 5.21 3.96 5.59 3.59C5.97 3.22 6.47 3 7 3H12.59C12.86 3 13.11 3.10999 13.3 3.28999L18.71 8.7C18.9 8.89 19 9.14 19 9.41V19C19 19.53 18.79 20.04 18.41 20.41C18.03 20.78 17.53 21 17 21Z",
  undefined: 0,
  transform: "translate(2,2)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#98EED5",
  d: "M17 21H7C6.47 21 5.96 20.79 5.59 20.41C5.22 20.03 5 19.53 5 19V5C5 4.47 5.21 3.96 5.59 3.59C5.97 3.22 6.47 3 7 3H12.59C12.86 3 13.11 3.10999 13.3 3.28999L18.71 8.7C18.9 8.89 19 9.14 19 9.41V19C19 19.53 18.79 20.04 18.41 20.41C18.03 20.78 17.53 21 17 21Z",
  undefined: 1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 1,
  stroke: "#265F58",
  d: "M12 16V10M12 10L9 13M12 10L15 13"
});

function SvgFileUploadFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadFilled);
export default __webpack_public_path__ + "static/media/file-upload-filled.d714e0b5.svg";
export { ForwardRef as ReactComponent };